
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    activeItem: {
      type: Object,
      default: () => ({}),
    },
  },
};
